import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ScrollComponent from './ScrollComponent';

const XIcon = ({ color, scrollIntoView, propsClassName }) => {
  return (
    <div
      className={classNames({
        'x-icon': true,
        [propsClassName]: propsClassName,
      })}
    >
      {scrollIntoView ? <ScrollComponent /> : null}
      <svg
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1000 1000.03"
        role="img"
      >
        <title>Close Out</title>
        <path
          fill={color}
          d="M606.68,499.65,978,128.33A75.18,75.18,0,0,0,871.67,22L500.36,393.32,128.86,21.83A75.18,75.18,0,0,0,22.54,23.68a74.94,74.94,0,0,0,.18,104.65L394,499.65,22.89,870.78A75.2,75.2,0,0,0,127.33,979l373-373,371.5,371.5A75.19,75.19,0,0,0,978,871Z"
          transform="translate(0.03 -0.01)"
        />
      </svg>
    </div>
  );
};

export default XIcon;

XIcon.propTypes = {
  color: PropTypes.string.isRequired,
};
